module.exports = "<p>footer works!</p>\n"